export const defaultInputClassConfigs: InputClassConfigMap = {
    small: {
        base: 'p-2 small-padding rounded',
        blur: '',
        focus: '',
    },
    large: {
        base: 'p-3 large-padding rounded',
        blur: '',
        focus: '',
    },
};
